import React from 'react'
import { connect } from 'react-redux'
import { DynamicModuleLoader } from 'redux-dynamic-modules'
import { Route } from 'react-router-dom'
import Loadable from 'react-loadable'
import modules, { init } from './modules'
import { getAppSalt, queryAgreements, queryNotice } from 'store/siteConfig'
import Loading from 'components/Loading'

export default function(route) {
  const NativeQuickPay = Loadable({
    loader: () => import('./NativeQuickPay'),
    render(loaded, props) {
      const Component = connect(
        (state) => ({
          paymentsNativeQuickPayState: state.paymentsNativeQuickPayState,
          siteConfig: state.siteConfig,
        }),
        {
          init,
          getAppSalt,
          queryAgreements,
          queryNotice,
        }
      )(loaded.default)
      return <Component {...props} />
    },
    loading: Loading
  })

  return (
    <Route
      path={`${route.match.path}/native-quick-pay`}
      render={routeProps => (
        <DynamicModuleLoader modules={[modules(routeProps.history)]}>
          <NativeQuickPay {...routeProps} />
        </DynamicModuleLoader>
      )}
    />
  )
}
